<template>
  <b-row>
    <b-col cols="8" class="text-truncate" :title="place">{{ place }}</b-col>
    <b-col class="text-right align-middle">
            <span>
                {{ count }}
                <svg svg-inline="" class="icon ml-2" @click="$emit('remove')" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="#969696" d="M7.5 15a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm.707-7.5l2.829-2.828-.708-.708L7.5 6.793 4.672 3.964l-.708.708L6.793 7.5l-2.829 2.828.708.708L7.5 8.207l2.828 2.829.708-.708L8.207 7.5z"/></svg>
            </span>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'SelectedCity',
  props: {
    placeId: {
      type: String,
      required: true,
    },
    place: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: false,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/css/variables';

  .row {
    background-color: #dcdcdc;
    color: #141414;
    font-weight: 400;
    margin: 0 0 24px 0;

    div {
      padding: 7.75px;
      font-family: $font-sans-serif-med;
      span {
        display: inline-flex;

        svg {
          align-self: center;
        }
      }
    }
  }

  .desktop {
    div {
      padding: 6px 8px 6px 8px;
    }
  }
</style>
